import React, { PropTypes } from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';
import { changeOffset } from '../actions/section';

function mapStateToProps(state, ownProps) {
  const { sections } = state;
  const { id } = ownProps;

  return { section: sections[id] };
}
function mapDispatchToProps(dispatch) {
  return {
    onOffsetChange: (section) => {
      if (section) {
        dispatch(changeOffset(section));
      }
    },
  };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Section extends React.Component {
  static propTypes = {
    section: PropTypes.object,
    onOffsetChange: PropTypes.func,
    color: PropTypes.string,
    sectionBg: PropTypes.string,
    contentBg: PropTypes.string,
    id: PropTypes.string,
    textAlign: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
  };

  componentDidMount() {
    if (this.props.id === 'intro') {
      return;
    }
    this.onResizeHandler();
    window.addEventListener('resize', this.onResizeHandler);
  }

  onResizeHandler = () => {
    const { id, onOffsetChange } = this.props;
    const sectionElement = this.refs.section;
    const offset = sectionElement.offsetTop;

    onOffsetChange({ id, offset });
  }

  render() {
    const {
      color,
      sectionBg,
      contentBg,
      children,
      id,
      textAlign,
      title,
      section,
    } = this.props;

    const wasInView = (section) ? section.wasInView : false;

    const styles = {
      wrapper: classnames({
        section: true,
        'section--white': color === 'white',
        'section--red': color === 'red',
        'section--green': color === 'green',
        'section--light-gray': color === 'light-gray',
        'section--dark-gray': color === 'dark-gray',
        'section--full-bg': !!sectionBg,

        'section--intro': id === 'intro',
        'section--history': id === 'history',
        'section--map': id === 'map',
        'section--quote': id === 'quote',
        'section--new-products': id === 'new-products',
        'section--all-products': id === 'all-products',
        'section--places': id === 'places',
        'section--certs': id === 'certs',

        'text-center': textAlign === 'center',

        'section--viewed': wasInView,
      }),
      beforeCrop: classnames('section--before-crop'),
      afterCrop: classnames('section--after-crop'),
      content: classnames('section--content'),
    };

    const $title = (title) ? <h1>{title}</h1> : null;

    const inlineStyles = {
      content: {
        backgroundImage: (contentBg) ? `url(${contentBg})` : 'none',
      },
      section: {
        backgroundImage: (sectionBg) ? `url(${sectionBg})` : 'none',
      },
    };

    return (
      <section className={styles.wrapper} ref="section" style={inlineStyles.section} id={id}>
        <div className={styles.beforeCrop}>
          <svg viewBox="0 0 100 6">
            <polygon points="0,0 100,0 100,1 0,6"></polygon>
          </svg>
        </div>
        <div className={styles.content} style={inlineStyles.content}>
          {$title}
          {children}
        </div>
        <div className={styles.afterCrop}>
          <svg viewBox="0 0 100 6">
            <polygon points="0,5 100,0 100,6 0,6"></polygon>
          </svg>
        </div>
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Section.jsx
 **/